import styles from './index.less';
import { F } from '@/utils/intl';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'umi';
import classNames from 'classnames';
import Drawer from '@/components/Drawer';
import CustomerName from '@/components/Customer/CustomerName';
import { Button, Space, Spin, Tabs } from 'antd';
import DrawerSection from '@/components/Drawer/DrawerSection';
import { FileOutlined } from '@ant-design/icons';
import type { ServiceRequestModel } from '@/typings/models/ServiceRequest';
import get from 'lodash/get';
import CustomerFiles from './CustomerFiles';
import ReadonlyForm from '../ReadonlyForm';
import { BsClipboardCheck } from '../Icons/CustomReactIcons';
import CustomerDetailHeader from './CustomerDetailHeader';
import LeadDetailsServiceRequests from '../Lead/LeadDetailsServiceRequests';

const TAB_KEYS = {
  SERVICE_REQUESTS: 'serviceRequests',
  UPLOADED_FILES: 'uploadedFiles',
};

const CustomerDrawer: React.FC = () => {
  const DEFAULT_SERVICE_REQUEST_DRAWER_LABEL = (
    <F id={'component.serviceRequest.drawerDefaultLabel'} />
  );

  const {
    visible,
    customer,
    nested,
    unSubscribeLoading,
    customerDetails = {},
    loading,
  } = useSelector(({ customers: { drawer, details }, loading }: DefaultRootState) => ({
    ...drawer,
    loading: loading.effects['customers/fetchDetails'],
    unSubscribeLoading: loading.effects['customers/unSubscribe'],
    customerDetails: details,
  }));

  const dispatch = useDispatch();
  const [activeTabKey, setActiveTabKey] = useState(TAB_KEYS.SERVICE_REQUESTS);

  function toggle() {
    dispatch({
      type: 'customers/toggleDrawer',
      payload: {
        customer: null,
      },
    });
  }

  function getCustomerId() {
    const link = customer?.link || customer?.links?.href;
    return link?.split('customers/')[1];
  }
const fetchCustomer = (id)=>{
    dispatch({
        type: 'customers/fetchDetails',
        payload: {
          customerId:id,
        },
      });

}
  useEffect(() => {
    if (!customer) {
      return;
    }
    const customerId = getCustomerId();
    if (visible) {
      fetchCustomer(customerId)

      dispatch({
        type: 'customers/fetchStates',
        payload: {
          customerId,
        },
      });
    }
  }, [customer, visible]);
  const customerId = getCustomerId();
  const details = customerId ? customerDetails[customerId] : {};

  function getUnsubscribeAction() {
    if (
      details &&
      details.Profile &&
      (details.Profile?.subscriber === undefined || details.Profile?.subscriber === true)
    )
      return (
        <Button
          loading={unSubscribeLoading}
          type={'link'}
          className="color-secondary"
          onClick={unsubscribeCustomer}
        >
          <F id={'pages.customer.unsubscribe'} defaultMessage={'Unsubscribe'} />
        </Button>
      );
    return null;
  }

  function unsubscribeCustomer() {
    dispatch({
      type: 'customers/unSubscribe',
      payload: {
        customerId,
      },
    });
  }
  function getServiceRequestDrawerLabel(serviceRequest: ServiceRequestModel) {
    const what = get(serviceRequest, 'what');
    const when = get(serviceRequest, 'when');
    return what && when ? `${what} - ${when}` : DEFAULT_SERVICE_REQUEST_DRAWER_LABEL;
  }

  const readonlySectionsConfig = details
    ? [
        {
          key: TAB_KEYS.SERVICE_REQUESTS,
          icon: <BsClipboardCheck width={20} />,
          title: 'entity.appointment.plural',
          visible: true,
          jsx: (
            <LeadDetailsServiceRequests
              leadDetails={{ service_requests: details.ServiceRequests }}
              addDisabled
            />
          ),
        },
        {
          key: TAB_KEYS.UPLOADED_FILES,
          icon: <FileOutlined width={20} />,
          title: 'pages.customer.uploadedFiles',
          defaultMessage: 'Uploaded Files',
          jsx: details?.UploadedFiles && (
            <CustomerFiles uploadedFiles={details?.UploadedFiles} />
          ),
        },
      ]
    : [];


  const tabs = readonlySectionsConfig.map((section) => ({
    key: section.key,
    label: (
      <Space>
        {section.icon}
        <F id={section.title} defaultMessage={section.defaultMessage} />
      </Space>
    ),
    children: section.jsx ? (
      section.jsx
    ) : (
      <ReadonlyForm {...section.form} />
    ),
  }));

  return (
    <div className={styles.drawerContainer}>
      <Drawer
        width={800}
        title={<CustomerName customer={details && details.Profile} drawer={false} />}
        open={visible}
        onOpenChange={toggle}
      >
        <Spin spinning={loading}>
          {details && (
            <div>
              <DrawerSection action={getUnsubscribeAction()}>
                <CustomerDetailHeader customerDetails={{...details.Profile,styles:details.Styles, id:customer?.id, links:customer?.links}} customer={{customer}} request={fetchCustomer}/>
              </DrawerSection>
              <Tabs
                className={classNames('ant-tab-type-button', styles.leadDetailsDrawerTabs)}
                activeKey={activeTabKey}
                onChange={(key) => setActiveTabKey(key)}
                items={tabs}
              />
            </div>
          )}
        </Spin>
      </Drawer>
    </div>
  );
};

export default CustomerDrawer;
